import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type QuoteProps = {
    className?: string;
};

const Quote: FunctionComponent<QuoteProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'quote'}
            viewBox="0 0 250 250"
        >
            <path d="M193.2 142h-25.1C171.4 95 209 59.4 250 35.1l-7.5-12.5c-65.2 32.6-100.3 88.6-100.3 131.2 0 46.8 14.2 75.2 59.3 75.2 20 0 40.1-21 40.1-42.7 0-22.5-14.2-44.3-48.4-44.3z" />
            <path d="M108 35.1l-7.5-12.5C35.3 55.2.2 111.2.2 153.8c0 46.8 14.2 75.2 59.3 75.2 20.1 0 40.1-21 40.1-42.7 0-22.6-14.2-44.4-48.5-44.4h-25C29.4 95 67 59.4 108 35.1z" />
        </svg>
    );
};
export default Quote;
